import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Row,
  VertButton,
  VertContainer,
} from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setTermUrl } from 'redux/Reducers/Spot/spotAproveRedemption';
import ynToBool from 'Utils/ynToBool';
import SpotDifal from './spotDifal';

export const SpotButtons = ({
  spot,
  isLoading,
  productsIds,
  callModal,
  isPMO,
  participantId,
}) => {
  const dispatch = useDispatch();
  const { termUrl } = useSelector((state) => state.SpotAproveRedemption);

  const [botaoValido, setBotaoValido] = useState(false);
  const [isValidToCheckout, setIsValidToCheckout] = useState(true);

  const handleIsValidToCheckout = () => {
    setIsValidToCheckout(!isValidToCheckout);
  };

  useEffect(() => {
    if (
      isPMO &&
      (spot.redemptionStatusId === 3 || spot.redemptionStatusId === 4)
    ) {
      if (termUrl === null || termUrl === undefined || termUrl === '') {
        setBotaoValido(true);
      } else {
        setBotaoValido(false);
      }
    }
  }, [termUrl, spot.redemptionStatusId]);

  useEffect(() => {
    if (spot.redemptionStatusId === 3 || spot.redemptionStatusId === 4) {
      return () => {
        setBotaoValido(false);
        dispatch(setTermUrl(null));
      };
    }
  }, [spot.redemptionStatusId]);

  return (
    <VertContainer className="container-button-view-redemption">
      {ynToBool(process.env.REACT_APP_HAS_DIFAL_VALIDATION) &&
        participantId == spot.participantId &&
        spot.type !== 4 && (
          <Row gutter={[16, 16]} verticalSpacing="regular" justify="center">
            <SpotDifal
              isValidToCheckout={isValidToCheckout}
              setIsValidToCheckout={handleIsValidToCheckout}
            />
          </Row>
        )}

      <Row justify="center" gutter={[16, 16]} verticalSpacing="regular">
        <Col xs={24} sm={12} md={8} lg={6}>
          <Button
            type="default"
            danger
            loading={isLoading}
            onClick={() => callModal('cancel')}
            className="button-view-redemption-danger"
          >
            Cancelar Solicitação
          </Button>
        </Col>

        {spot.redemptionStatusId === 2 && isPMO && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <VertButton
              type="default"
              className="button-view-redemption"
              loading={isLoading}
              onClick={() => callModal('cotacao')}
            >
              Voltar para Cotação
            </VertButton>
          </Col>
        )}

        <Col xs={24} sm={12} md={8} lg={6}>
          <VertButton
            type="highlight"
            className="button-view-redemption"
            loading={isLoading}
            onClick={() => callModal('approve')}
            disabled={
              productsIds.length === 0 || botaoValido || !isValidToCheckout
            }
          >
            Aprovar Solicitação
          </VertButton>
        </Col>
      </Row>
    </VertContainer>
  );
};

SpotButtons.propTypes = {
  spot: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  callModal: PropTypes.func,
  isPMO: PropTypes.bool,
};
